// PubSub is a super basic pub/sub system.

type Responder<T> = (data: T) => void;

export default class PubSub<T> {
	private _subscribers: Set<Responder<T>> = new Set();

	public subscribe(responder: Responder<T>): void {
		this._subscribers.add(responder);
	}

	public unsubscribe(responder: Responder<T>): void {
		this._subscribers.delete(responder);
	}

	public publish(data: T): void {
		Array.from(this._subscribers).forEach((responder) => responder(data));
	}
}
